export default __webpack_public_path__ + "static/media/blank_my_activityD.edd628ca.svg";